import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import Avatar from './../img/avatar-2-64.png';

export class UserDropdown extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false
        };
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }


    render() {
        return (
            <div className="site-header-shown">
                <div className="dropdown user-menu">
                    <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                        <DropdownToggle
                            tag="span"
                            onClick={this.toggle}
                            data-toggle="dropdown"
                            aria-expanded={this.state.dropdownOpen}
                        >
                            <div className="dropdown-toggle">   <img alt="user" src={Avatar} /> </div>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/"><span className="font-icon glyphicon glyphicon-log-out"></span>Logout</NavLink>
                                </NavItem>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>

                </div>
            </div>
        )
    }
}